{
  "button_refresh": {
    "defaultMessage": "Refresh",
    "description": "Label for button to refresh moment list"
  },
  "button_print": {
    "defaultMessage": "Print",
    "description": "Label for button to print moment"
  },
  "button_select": {
    "defaultMessage": "Select",
    "description": "Label for button to print moment"
  },
  "button_process": {
    "defaultMessage": "Process",
    "description": "Label for button to start a process"
  },
  "button_back_to_login": {
    "defaultMessage": "Back to Login",
    "description": "Label for button to back to login"
  },
  "button_forgot": {
    "defaultMessage": "Forgot",
    "description": "Label for button to do forgot password option"
  },
  "button_login": {
    "defaultMessage": "Login",
    "description": "Label for button to closing portion"
  },
  "button_close": {
    "defaultMessage": "Close",
    "description": "Label for button to closing portion"
  },
  "button_ok": {
    "defaultMessage": "OK",
    "description": "Label for button to acknowledge a message"
  },
  "button_done": {
    "defaultMessage": "DONE",
    "description": "Label for button to confirm user is finished"
  },
  "button_enter": {
    "defaultMessage": "Enter",
    "description": "Label for submit button on kiosk login screen"
  },
  "button_continue": {
    "defaultMessage": "Continue",
    "description": "Label for submit button on kiosk login screen"
  },
  "button_customer_login": {
    "defaultMessage": "Back to Customer Login",
    "description": "Label for button to return to customer login"
  },
  "button_lookup_gallery": {
    "defaultMessage": "Lookup Gallery",
    "description": "Label for submit button on kiosk login screen"
  },
  "button_view_gallery": {
    "defaultMessage": "View Gallery",
    "description": "Label for button to view gallery"
  },
  "button_view_my_gallery": {
    "defaultMessage": "View My Gallery",
    "description": "Label for button to view gallery"
  },
  "button_more_images": {
    "defaultMessage": "More Images",
    "description": "Label for button to view image catalog"
  },
  "button_add_more_images": {
    "defaultMessage": "Add More Images",
    "description": "Label for button to view image catalog"
  },
  "button_price_guide": {
    "defaultMessage": "Price Guide",
    "description": "Label for button to view price guide"
  },
  "button_cancel": {
    "defaultMessage": "Cancel",
    "description": "Label for button to cancel an action"
  },
  "button_remove": {
    "defaultMessage": "Remove",
    "description": "Label for button to remove an image from the order"
  },
  "button_remove_prints": {
    "defaultMessage": "Remove Prints",
    "description": "Label for button to remove an image from the order"
  },
  "button_selected_print_sizes": {
    "defaultMessage": "Selected Print Sizes ({quantity})",
    "description": "Label for button to view selected print sizes"
  },
  "button_back": {
    "defaultMessage": "Back",
    "description": "Label for button that returns user to previous screen"
  },
  "button_edit_order": {
    "defaultMessage": "Edit Order",
    "description": "Label for button that returns user to order edit screen"
  },
  "button_approve": {
    "defaultMessage": "Approve",
    "description": "Label for button that grants staff approval"
  },
  "button_review_and_purchase": {
    "defaultMessage": "Review and Purchase",
    "description": "Label for button that shows cart screen"
  },
  "button_purchase": {
    "defaultMessage": "Purchase",
    "description": "Label for button that completes a purchase"
  },
  "button_complete_purchase": {
    "defaultMessage": "Complete Purchase",
    "description": "Label for button that completes a purchase"
  },
  "button_bill_to_room": {
    "defaultMessage": "Bill to Room",
    "description": "Label for button that bills a charge to a hotel room"
  },
  "button_stripe_reader": {
    "defaultMessage": "Stripe Reader",
    "description": "Label for button that selects stripe reader as payment method"
  },
  "button_tilby": {
    "defaultMessage": "Tilby",
    "description": "Label for button that selects tilby as payment method"
  },
  "button_credit_or_debit_card": {
    "defaultMessage": "Credit or Debit Card",
    "description": "Label for button that selects card as payment method"
  },
  "button_view_receipt": {
    "defaultMessage": "View Receipt",
    "description": "Label for button to view receipt"
  },
  "button_new_order": {
    "defaultMessage": "New Order",
    "description": "Label for button to begin a new order"
  },
  "button_buy_more": {
    "defaultMessage": "Buy More",
    "description": "Label for button to begin a new order"
  },
  "button_send_link": {
    "defaultMessage": "Send Link",
    "description": "Label for button to send link to purchase via email"
  },
  "button_send_links": {
    "defaultMessage": "Send Links",
    "description": "Label for button to send links to purchase via email"
  },
  "button_log_out": {
    "defaultMessage": "Log Out",
    "description": "Label for button to end session"
  },
  "button_stay": {
    "defaultMessage": "Stay",
    "description": "Label for button to remain logged in instead of being automatically logged out"
  },
  "button_got_it": {
    "defaultMessage": "Got it",
    "description": "Label for phrase got it"
  },
  "button_download": {
    "defaultMessage": "Download",
    "description": "Label for download"
  },
  "button_share": {
    "defaultMessage": "Share",
    "description": "Label for share"
  },
  "button_image_view_zoom": {
    "defaultMessage": "Zoom in/out",
    "description": "Label for zoom in and out"
  },
  "button_image_view_previous": {
    "defaultMessage": "Previous(arrow left)",
    "description": "pwa.image.view.previous.text"
  },
  "button_image_view_next": {
    "defaultMessage": "Next(arrow right)",
    "description": "pwa.image.view.next.text"
  },
  "button_toggle_access_codes": {
    "defaultMessage": "Toggle Access Codes",
    "description": "Label to toggle the access code display in pre-print gallery"
  },
  "button_review_cart": {
    "defaultMessage": "Cart",
    "description": "Label for button that shows cart review screen"
  },
  "button_back_to_cart": {
    "defaultMessage": "Gallery",
    "description": "Label for button that returns user to mobile cart gallery"
  }
}